import panelModule from "./r2PanelModule"
import panelView from "./panelView.html"

panelModule.directive("nlgPanel", [()=>{
    return {
        restrict: "E",
        template: panelView,
        transclude: true
    }
}])